import { render, staticRenderFns } from "./UiList.vue?vue&type=template&id=ede9ce3c&scoped=true"
import script from "./UiList.vue?vue&type=script&lang=js"
export * from "./UiList.vue?vue&type=script&lang=js"
import style0 from "./UiList.vue?vue&type=style&index=0&id=ede9ce3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ede9ce3c",
  null
  
)

export default component.exports